import { JSONSchema7Object, ConfigurableFormConfig } from "../../../types";
import * as formElements from "./formElements";
//import validateSchema from "./customerConsent.json";
import formElementsSchema from "./formElements.json";

export const formConfig: ConfigurableFormConfig = {
  fields: [
    {
      ...formElements.sectionHeader,
      label: "customer.advisorForm.title"
    },
    {
      ...formElements.sectionText,
      label: "customer.advisorForm.intro"
    },
    {
      ...formElements.fieldTags,
      id: "clientPotential",
      name: "clientPotential",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.clientPotential.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "children",
      name: "children",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.children.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "upcomingEvent",
      name: "upcomingEvent",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.upcomingEvent.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "beverage",
      name: "beverage",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.beverage.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "doNotServe",
      name: "doNotServe",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.doNotServe.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "favoriteCollection",
      name: "favoriteCollection",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.favoriteCollection.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "category",
      name: "category",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.category.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "material",
      name: "material",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.material.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "pavedStacking",
      name: "pavedStacking",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.pavedStacking.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "pet",
      name: "pet",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.pet.title"
        }
      }
    },
    {
      ...formElements.fieldTags,
      id: "invitationType",
      name: "invitationType",
      label: "",
      props: {
        inputProps: {
          label: "customer.advisorForm.invitationType.title"
        }
      }
    },
    {
      ...formElements.sectionHeader,
      label: "customer.advisorForm.notes.title",
      props: {
        className: "align-left m-bottom-small"
      }
    },
    {
      ...formElements.sectionText,
      label: "customer.advisorForm.notes.intro",
      props: {
        className: "align-left"
      }
    },
    {
      ...formElements.fieldTextarea,
      id: "notes",
      name: "notes",
      label: "",
      props: {
        placeholder: "customer.advisorForm.notes.placeholder",
        inputProps: {
          rows: "5"
        }
      },
      errorMessage: "customer.data.fields.notes.errors.required"
    }
  ],
  //validateSchema: validateSchema as JSONSchema7Object,
  refSchemas: [formElementsSchema as JSONSchema7Object],
  labels: {
    buttonBack: "general.buttons.back.label",
    buttonNext: "general.buttons.continue.label",
    buttonSubmit: "general.buttons.submit.label",
    buttonReset: "reset"
  },
  buttonsOnTop: true
};

export default formConfig;
